import React, { Component } from 'react';
import { convertToMoney } from '../utils/formats';
import {
    MONTO_MIN, MONTO_MAX, CANTIDAD_MAX, errorDeMonto, errorDeCantidad, ventaValida, totalDeLaVenta,
} from '../utils/giftCards';

// Tarjeta "Gift card" de la venta de mostrador (FR-001): un monto y una cantidad, un solo monto
// por venta (montos distintos = ventas separadas). Emite `{ amount, quantity }` cuando los dos
// valen, o `null` si el monto está vacío o mal: una venta con un monto inválido no lleva tarjeta,
// y el cajero ve por qué antes de confirmar.
class GiftCardSaleComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { amount: '', quantity: '1' };
    }

    update = (patch) => {
        this.setState(patch, () => {
            this.props.onChangeData(ventaValida(this.state.amount, this.state.quantity));
        });
    }

    render() {
        const { amount, quantity } = this.state;
        const errorMonto = errorDeMonto(amount);
        const errorCantidad = amount !== '' ? errorDeCantidad(quantity) : null;
        const sale = ventaValida(amount, quantity);
        return (
            <div className="col-lg-12">
                <div className="card card-small mb-4">
                    <div className="card-header border-bottom">
                        <span>Gift card</span>
                    </div>
                    <div className="card-body p-3">
                        <div className="row align-items-end">
                            <div className="form-group col-md-4 mb-2">
                                <label htmlFor="gift_card_amount">Monto ($)</label>
                                <input
                                    type="number"
                                    id="gift_card_amount"
                                    className={`form-control ${errorMonto ? 'is-invalid' : ''}`}
                                    min={MONTO_MIN}
                                    max={MONTO_MAX}
                                    step="1"
                                    placeholder="Vacío = sin gift card"
                                    value={amount}
                                    onChange={(e) => this.update({ amount: e.target.value })}
                                />
                            </div>
                            <div className="form-group col-md-3 mb-2">
                                <label htmlFor="gift_card_quantity">Cantidad</label>
                                <input
                                    type="number"
                                    id="gift_card_quantity"
                                    className={`form-control ${errorCantidad ? 'is-invalid' : ''}`}
                                    min="1"
                                    max={CANTIDAD_MAX}
                                    step="1"
                                    value={quantity}
                                    onChange={(e) => this.update({ quantity: e.target.value })}
                                />
                            </div>
                            <div className="form-group col-md-5 mb-2" style={{ textAlign: 'right' }}>
                                {sale ? (
                                    <span>
                                        {sale.quantity} × $ {convertToMoney(sale.amount)} ={' '}
                                        <strong>$ {convertToMoney(totalDeLaVenta(sale))}</strong>
                                    </span>
                                ) : null}
                            </div>
                        </div>
                        {errorMonto || errorCantidad ? (
                            <div className="text-danger" style={{ fontSize: '0.85rem' }}>{errorMonto || errorCantidad}</div>
                        ) : (
                            <small className="text-muted">
                                Se cobra aparte: no recibe descuentos ni se paga con saldo a favor. Al confirmar se
                                muestran los códigos para copiarlos en las tarjetas.
                            </small>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default GiftCardSaleComponent;
